import { useEffect, useRef } from 'react';
import { useSocketStore } from '../../stores/useSocketStore';
import { useTripStatusAnalysisStore } from '../../stores/analysis/useTripStatusAnalysisStore';

export function useTripStatusAnalysisSocket() {

    const socket = useSocketStore(
        state => state.socket
    );

    const countRef = useRef(0);

    useEffect(() => {

        if (!socket) {
            return;
        }

        const {
            setStatus
        } = useTripStatusAnalysisStore.getState();

        const handleStatus = (data) => {

            countRef.current++;

            console.log(
                'status',
                countRef.current
            );

            setStatus(data);

        };

        socket.on('trip:status:analysis', handleStatus);

        return () => {

            socket.off('trip:status:analysis', handleStatus);

        };

    }, [socket]);

}